module.exports = __webpack_public_path__ + "img/mf.c504bc79.svg";